import { onInvisibilityChange } from '../actions/internalActions';
import { showSxS } from '../actions/publicActions';
import getOrCreateSxSStoreData from '../store/Store';
import { mutator } from 'satcheljs';

mutator(showSxS, actionMessage => {
    getOrCreateSxSStoreData(actionMessage.sxsId).isInvisible = false;
});

mutator(onInvisibilityChange, actionMessage => {
    const { invisible, sxsId } = actionMessage;
    getOrCreateSxSStoreData(sxsId).isInvisible = invisible;
});
